var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "guideline-setting" },
    [
      _c("div", { staticClass: "guideline-header" }, [
        _c("div", { staticClass: "guideline-header__information" }, [
          _vm.lastUpdatedBy
            ? _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t("lastUpdatedBy", [
                      _vm.lastUpdatedBy,
                      _vm.lastUpdatedAt,
                    ])
                  )
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.aclHelper.getSettingsUpdateAccess()
          ? _c("div", { staticClass: "guideline-header__btns" }, [
              !_vm.isEditing && _vm.guidelines.length
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn--darkblue",
                      attrs: { role: "publish-button" },
                      on: {
                        click: function () {
                          return _vm.openPublishModal()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("action.publish")) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isEditing
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn--orange",
                      attrs: { role: "edit-button" },
                      on: {
                        click: function () {
                          return _vm.enableEdit()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("action.edit")) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isEditing
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn--darkblue",
                      attrs: { role: "cancel-button" },
                      on: {
                        click: function () {
                          return _vm.cancelEdit()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("action.cancel")) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isEditing
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn--orange",
                      attrs: { role: "save-button" },
                      on: {
                        click: function () {
                          return _vm.save()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("action.save")) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.guidelines.length
        ? _c(
            "section",
            { staticClass: "guideline" },
            _vm._l(_vm.guidelines, function (section, sectionIndex) {
              return _c(
                "Collapse",
                {
                  key:
                    sectionIndex +
                    "-" +
                    section.displayOrder +
                    "-" +
                    section.value,
                  staticClass: "guideline-setting-collapse",
                  attrs: {
                    id: "guideline-setting-collapse-" + sectionIndex,
                    withBorder: false,
                    titleContainerClass: {
                      "is-editing": _vm.isEditing || _vm.onlyLine,
                    },
                    expandIcons: _vm.onlyLine ? [] : undefined,
                  },
                },
                [
                  !_vm.onlyLine
                    ? [
                        _c(
                          "div",
                          {
                            class: [
                              "guideline-section",
                              "section_group_" + sectionIndex,
                              "" + section.class,
                            ],
                            attrs: { slot: "title" },
                            slot: "title",
                          },
                          [
                            _c("TextField", {
                              staticClass: "guideline-section-edit__order",
                              attrs: {
                                showColon: false,
                                value: _vm.isEditing
                                  ? section.displayOrder
                                  : _vm.displayOrder(section),
                                readonly: !_vm.isEditing,
                                required: _vm.isEditing,
                                defaultEmpty: "",
                              },
                              on: {
                                updateValue: function (val) {
                                  return _vm.updateSectionDisplayOrder(
                                    val,
                                    sectionIndex
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("TextField", {
                              staticClass: "guideline-section__content",
                              attrs: {
                                showColon: false,
                                placeholder: _vm.$t(
                                  "guideline.sectionInputHint"
                                ),
                                value: section.value,
                                readonly: !_vm.isEditing,
                                required: _vm.isEditing,
                                defaultEmpty: "",
                              },
                              on: {
                                updateValue: function (val) {
                                  return _vm.updateSectionContent(
                                    val,
                                    sectionIndex
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.isEditing
                          ? _c(
                              "div",
                              {
                                staticClass: "additional-container",
                                class: { hidden: !_vm.isEditing },
                                attrs: { slot: "additional" },
                                slot: "additional",
                              },
                              [
                                _vm.isEditing
                                  ? _c(
                                      "DottedMenu",
                                      {
                                        ref: "dottedMenu_section",
                                        refInFor: true,
                                        staticClass: "guideline-dropdown",
                                        attrs: {
                                          color: "darkblue",
                                          enableClickOutClose: true,
                                        },
                                      },
                                      [
                                        _c(
                                          "HKLbutton",
                                          {
                                            on: {
                                              click: function () {
                                                return _vm.addSection(
                                                  sectionIndex,
                                                  true
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "action.addSectionAbove"
                                                  )
                                                ) +
                                                "\n          "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "HKLbutton",
                                          {
                                            on: {
                                              click: function () {
                                                return _vm.addSection(
                                                  sectionIndex,
                                                  false
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "action.addSectionBelow"
                                                  )
                                                ) +
                                                "\n          "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "HKLbutton",
                                          {
                                            on: {
                                              click: function () {
                                                return _vm.deleteSection(
                                                  sectionIndex
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(
                                                  _vm.$t("action.deleteSection")
                                                ) +
                                                "\n          "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "guideline-section__line",
                      attrs: {
                        slot: "content",
                        id: "guideline-setting-section-" + sectionIndex,
                      },
                      slot: "content",
                    },
                    _vm._l(section.sectionContent, function (line, lineIndex) {
                      return _c(
                        "div",
                        {
                          key:
                            lineIndex +
                            "-" +
                            line.displayOrder +
                            "-" +
                            line.value,
                          class: [
                            "guideline-line",
                            "line_group_" + sectionIndex + "_" + lineIndex,
                            "" + line.class,
                          ],
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "guideline-line__line" },
                            [
                              _vm.isLineOrderEditable
                                ? _c("TextField", {
                                    staticClass: "guideline-line-edit__order",
                                    attrs: {
                                      showColon: false,
                                      value: _vm.isEditing
                                        ? line.displayOrder
                                        : _vm.displayOrder(line),
                                      readonly: !_vm.isEditing,
                                      required: _vm.isEditing,
                                      defaultEmpty: "",
                                    },
                                    on: {
                                      updateValue: function (val) {
                                        return _vm.updateLineDisplayOrder(
                                          val,
                                          sectionIndex,
                                          lineIndex
                                        )
                                      },
                                    },
                                  })
                                : _c(
                                    "span",
                                    { staticClass: "guideline-line__order" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.displayOrder(line, {
                                              isSub: true,
                                              plusOne:
                                                !section.sectionContent[0]
                                                  .order,
                                            })
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                              _vm._v(" "),
                              _c("TextField", {
                                staticClass: "guideline-line__content",
                                attrs: {
                                  placeholder: _vm.$t(
                                    "guideline.lineInputHint"
                                  ),
                                  value: line.value,
                                  showColon: false,
                                  readonly: !_vm.isEditing,
                                  required: _vm.isEditing,
                                  defaultEmpty: "",
                                },
                                on: {
                                  updateValue: function (val) {
                                    return _vm.updateLineContent(
                                      val,
                                      sectionIndex,
                                      lineIndex
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm.isEditing
                                ? _c(
                                    "DottedMenu",
                                    {
                                      ref: "dottedMenu_line_" + line.id,
                                      refInFor: true,
                                      staticClass: "guideline-dropdown",
                                      attrs: { enableClickOutClose: true },
                                    },
                                    [
                                      _c(
                                        "HKLbutton",
                                        {
                                          on: {
                                            click: function () {
                                              return _vm.addLine({
                                                sectionIndex: sectionIndex,
                                                lineIndex: lineIndex,
                                                isAbove: true,
                                                id: line.id,
                                              })
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("action.addLineAbove")
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "HKLbutton",
                                        {
                                          on: {
                                            click: function () {
                                              return _vm.addLine({
                                                sectionIndex: sectionIndex,
                                                lineIndex: lineIndex,
                                                isAbove: false,
                                                id: line.id,
                                              })
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("action.addLineBelow")
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "HKLbutton",
                                        {
                                          on: {
                                            click: function () {
                                              return _vm.deleteLine(
                                                sectionIndex,
                                                lineIndex
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("action.deleteLine")
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ],
                2
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "cancelModal",
          attrs: { showCloseBtn: false, modalId: _vm.cancelModalId },
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("div", { staticClass: "font-bold" }, [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("cancelChanges")) + "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn--darkblue",
                attrs: { type: "button", role: "modal-no-button" },
                on: {
                  click: function () {
                    return _vm.closeCancelModal()
                  },
                },
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("action.no")) + "\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn--orange",
                attrs: { type: "button", role: "modal-yes-button" },
                on: {
                  click: function () {
                    return _vm.cancel()
                  },
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("action.yesContinue")) +
                    "\n      "
                ),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "publishModal",
          attrs: { showCloseBtn: false, modalId: _vm.publishModalId },
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("div", { staticClass: "font-bold" }, [
              _vm._v("\n        " + _vm._s(_vm.publishHint) + "\n      "),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn--darkblue",
                attrs: { type: "button", role: "modal-no-button" },
                on: {
                  click: function () {
                    return _vm.closePublishModal()
                  },
                },
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("action.no")) + "\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn--orange",
                attrs: { type: "button", role: "modal-yes-button" },
                on: {
                  click: function () {
                    return _vm.publish()
                  },
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("action.yesContinue")) +
                    "\n      "
                ),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }